import React from 'react';
import { Img, Icon, Button } from 'components';
import { Section, Box, Text } from 'styles';

export function Section4(props) {
  return (
    <Section $backgroundColor="primary10">
      <Box $maxWidth={1600} $padding="80px 40px" $mPadding="40px 20px" $margin="auto">
        <Box $width="fit-content" $margin="auto">
          <Button $type="badge">
            <Icon name="badgeIcon" />
            App Screen
          </Button>
        </Box>

        <Text $type="b40" $mType="b28" $padding="24px 0 16px" $textAlign="center">
          이렇게 작동합니다
        </Text>
        <Text $type="18" $mType="16" $textAlign="center" $color="gray600">
          응답자는 설문에 참여하고 포인트를 받습니다.
          <br />
          광고주는 설문 완료 후 배너로 전환까지 유도할 수 있습니다.
        </Text>
        <Box $margin="auto" $width="fit-content" $padding="64px 40px 80px" $mPadding="24px 0" $maxWidth={1600}>
          <Img desktopSrc="main4" mobileSrc="moMain4" $width="100%" />
        </Box>

      </Box>
    </Section>
  );
}